export default __webpack_public_path__ + "static/PLCide-31a2645d7dae9e3ca7bc1ac7e7e43dca.png";